/** Shared Excel column enums for Retail Items Setup (Spa / Golf). */

export enum RetailItemExcelHeader {
  ItemNumber = "Item Number",
  ItemDescription = "Item Description",
  Category = "Category",
  SubCategory1 = "Sub Category 1",
  SubCategory2 = "Sub Category 2",
  SubCategory3 = "Sub Category 3",
  SubCategory4 = "Sub Category 4",
  SubCategory5 = "Sub Category 5",
  UnitOfMeasure = "Unit of Measure",
  SalesPrice = "Sales price",
  BarCode = "Bar Code",
  SecondaryBarCode = "Secondary Bar Code",
  Tax = "Tax",
  ItemType = "Item Type",
  CommissionPercent = "Commission Percent",
  CommissionableItem = "Commissionable Item",
  CommissionRequired = "Commission Required",
  UseInventory = "Use Inventory",
  GroupingKey = "Grouping Key",
  OpenItems = "Open Items",
  Multipacks = "Multipacks",
  Gratuity = "Gratuity",
  ServiceCharge = "Service Charge",
  OutletCode = "Outlet Code",
  Quantity = "Quantity",
  UnitCost = "Unit Cost",
  ItemPar = "Item Par",
  OutletSwitch = "Outlet Switch",
  AllowEarn = "Allow Earn",
}

export enum RetailItemExcelSourceField {
  ItemNumber = "Item Number",
  ItemDescription = "Item Description",
  Category = "Category",
  SubCategory1 = "Sub Category 1",
  SubCategory2 = "Sub Category 2",
  SubCategory3 = "Sub Category 3",
  SubCategory4 = "Sub Category 4",
  SubCategory5 = "Sub Category 5",
  UnitOfMeasure = "Unit of Measure",
  SalesPrice = "Sales Price",
  BarCode = "Bar Code",
  SecondaryBarCode = "Secondary Bar Code",
  Tax = "Tax",
  ItemType = "Item Type",
  CommissionPercent = "Commission Percent",
  CommissionableItem = "Commissionable Item",
  CommissionRequired = "Commission Required",
  UseInventory = "Use Inventory",
  GroupingKey = "Grouping Key",
  OpenItems = "Open Items",
  Multipacks = "Multipacks",
  Gratuity = "Gratuity",
  ServiceCharge = "Service Charge",
  OutletCode = "Outlet Code",
  /** Fallback keys read when Outlet Code is missing. */
  Outlet = "Outlet",
  OutletName = "Outlet Name",
  Quantity = "Quantity",
  UnitCost = "Unit Cost",
  ItemPar = "Item Par",
  OutletSwitch = "Outlet Switch",
  AllowEarn = "Allow Earn",
}
